import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SharedModule } from '../../shared/shared.module';
import { NgxSelectModule } from 'ngx-select-ex';

import { ModalModule } from 'ngx-bootstrap/modal';

import { QuestionnaireFillComponent } from './questionnaire-fill/questionnaire-fill.component'


const routes: Routes = [
  //{ path: '', redirectTo: 'list' },
  { path: 'fill/:id', component: QuestionnaireFillComponent },
];

@NgModule({
  declarations: [
    QuestionnaireFillComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    ModalModule.forRoot(),
    SharedModule,
    NgxSelectModule
  ],
  exports: [
    RouterModule,
    QuestionnaireFillComponent
  ]
})
export class QuestionnaireResultModule { }
